export default {
  year: 2023,
  edition: "제 19회",
  date: "2023년 11월 11일 토요일",
  time: "오후 2시 ~ 5시",
  location: "다산관 D104/D105",
  links: {
    problems: {
      BOJ: "https://www.acmicpc.net/category/996",
    },
    solutions: {
      PDF: "/downloads/spc/2023/solutions.pdf",
    },
  },
  authors: ["정회윤", "박한나", "강효규", "김동건", "채성우", "유호영"],
  contests: [
    {
      title: "SPC 2023 Master",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "8", "박성준"],
        ["2", "6", "이준석"],
        ["3", "5", "심진희"],
        ["4", "4", "김주현"],
        ["5", "4", "김도현"],
        ["6", "4", "김현종"],
      ],
      award: ["gold", "silver", "silver", "bronze", "bronze", "bronze"],
      links: [["스코어보드", "https://www.acmicpc.net/contest/spotboard/1157"]],
    },
    {
      title: "SPC 2023 Champion",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "7", "송근수"],
        ["2", "6", "이승형"],
        ["3", "4", "계수민"],
        ["4", "4", "이상윤"],
        ["5", "3", "박원우"],
        ["6", "3", "한의현"],
        ["7", "3", "공하영"],
      ],
      award: [
        "winner",
        "gold",
        "silver",
        "silver",
        "bronze",
        "bronze",
        "bronze",
      ],
      links: [["스코어보드", "https://www.acmicpc.net/contest/spotboard/1158"]],
    },
  ],
};
